import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import country_currency from "./country_currency.json";

function Howto() {
  const [copied, setCopied] = React.useState(false);
  const [numberValid, setNumberValid] =useState(false);
  const [inputFieldsHt, setInputFieldsHt] = useState([]) 
  const [inputFieldsHtTool, setInputFieldsHtTool] = useState([])
  const [istrueUrl, setIsTrueIMg] = React.useState(false);
  const [istrueStepUrl, setIsTrueURL] = React.useState([0, false]);
  const [istrueImgUrls, setImageUrlvalid] = React.useState([0, false]);
  const [inputFieldsHtStep, setInputFieldsHtStep] = useState([{
    step:'', image:'', name:'', url:''
}])
  const [inputFieldsHt0, setInputFieldsHt0] = useState({
    name: '',
    description:'',
    totalTime:'',
    estimateitme:'',
    image:'',
    currency:'',
  })
  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  }; 
  const handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if(name==='totalTime'){
        if(!isNaN(value)){
          setNumberValid(false);
        }else{
          setNumberValid(true);
        }
    }
    if(name==='image')
    {
      let isTrueUrlvalid = !value || urlPatternValidation(value);
      if(isTrueUrlvalid === false)
      {
        setIsTrueIMg(true);
      }
      else{
        setIsTrueIMg(false);
      } 
    }
    setInputFieldsHt0((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }})
  }
  const handleChange4 = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...inputFieldsHt];
    list[index][name] = value;
    setInputFieldsHt(list);
  }

  const handleChangeTool = (index, evnt) => {
    const { name, value } = evnt.target;
    const list = [...inputFieldsHtTool];
    list[index][name] = value;
    setInputFieldsHtTool(list);
  }
  const handleChangeStep = (index, evnt) => {
    const { name, value } = evnt.target;
    if(name==='url')
    {
      let isTrueUrlval = !value || urlPatternValidation(value);
      if(isTrueUrlval === false)
      {
        setIsTrueURL([index, true]);
      }
      else{
        setIsTrueURL([index, false]);
      }
    }
    if(name==='image')
    {
      let isTrueImaUrlvalid = !value || urlPatternValidation(value);
      if(isTrueImaUrlvalid === false)
      {
        setImageUrlvalid([index, true]);
      }
      else{
        setImageUrlvalid([index, false]);
      }
    }
    const list = [...inputFieldsHtStep];
    list[index][name] = value;
    setInputFieldsHtStep(list);
  }
  function MyButton(props) {
    return <button {...props} />
  } 
  const addInputFieldHt = () => {
    setInputFieldsHt([...inputFieldsHt, {
      name: '',
    }])

  }
  const removeInputFieldsHt = (index) => {
    const rows = [...inputFieldsHt];
    rows.splice(index, 1);
    setInputFieldsHt(rows);
  }
  const addInputFieldHtTool = () => {
    setInputFieldsHtTool([...inputFieldsHtTool, {
      type: "Question",
      name: '',
      acceptedAnswer:  {
        type: "Answer",
        text: ""
      },
    }])

  }
  const removeInputFieldsHtTool = (index) => {
    const rows = [...inputFieldsHtTool];
    rows.splice(index, 1);
    setInputFieldsHtTool(rows);
  }

  const addInputFieldHtStep = () => {
    setInputFieldsHtStep([...inputFieldsHtStep, {
      step:'', image:'', name:'', url:''
    }])

  }
  const removeInputFieldsHtStep = (index) => {
    const rows = [...inputFieldsHtStep];
    rows.splice(index, 1);
    setInputFieldsHtStep(rows);
  }
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, [])
  
   
  
  const supply = (inputFieldsHt.length > 0)?(inputFieldsHt.length === 1)?
   `"supply": {

        "@type": "HowToSupply",
        "name": "`+inputFieldsHt[0].name+`"
      }`:`"supply": [ 
            `+
      inputFieldsHt.map((items) =>
            `{
                "@type": "HowToSupply",
                "name": "`+items.name+`"
            }`

            )
            + ` 
          ],`:'';

  const tool = (inputFieldsHtTool.length > 0)?(inputFieldsHtTool.length === 1)?
   `"tool": [
            {
                "@type": "HowToTool",
                "name": "`+inputFieldsHtTool[0].name+`"
            }
          ],`:`"tool": [
          `+
          inputFieldsHtTool.map((items) =>
              ` {
                "@type": "HowToTool",
                "name": "`+items.name+`"
            }`
          )
          + `
          ],`:'';
  const step = (inputFieldsHtStep.length > 0)?(inputFieldsHtStep.length === 1)?
    `"step": [
            {
                  "@type": "HowToStep",
                  "text": "`+inputFieldsHtStep[0].step+`",
                  "image": "`+inputFieldsHtStep[0].image+`",
                  "name": "`+inputFieldsHtStep[0].name+`",
                  "url": "`+inputFieldsHtStep[0].url+`"
            }
        ]`:`"step": [
        `+
        inputFieldsHtStep.map((items) =>
      `   {
                "@type": "HowToStep",
                "text": "`+items.step+`",
                "image": "`+items.image+`",
                "name": "`+items.name+`",
                "url": "`+items.url+`"
          }`)+`
        ]`:'';
   
    const HtIsMyCopy2 = 
    `<script type="application/ld+json">
      {
          "@context": "https://schema.org/", 
          "@type": "HowTo", 
          "name": "`+inputFieldsHt0.name+`",
          "description": "`+inputFieldsHt0.description+`",
          "image": "`+inputFieldsHt0.image+`",
          "totalTime": "PT`+inputFieldsHt0.totalTime+`M",
          "estimatedCost": {
              "@type": "MonetaryAmount",
              "currency": "`+inputFieldsHt0.currency+`",
              "value": "`+inputFieldsHt0.estimateitme+`"
          },
          `+supply+`
          `+tool+`
          `+step+`    
      }
    </script><!--HowtoList Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;

    const resetFun = () => {
      const resetVal = {
        name: '',
        description:'',
        totalTime:'',
        estimateitme:'',
        image:'',
        currency:'',
      };
      setInputFieldsHt0(resetVal);
      setInputFieldsHtStep([]);
      setInputFieldsHtTool([]);
      setInputFieldsHt([]);
    }

    return (
        <div className='row mt-5 howto_row'>
          <div className='col-md-8 mb-5 border ps-0'>
              <div className='mt-2 mb-2 article_title'><i className="fa-solid fa-list me-3"></i><b>How-to</b> </div>
              <div className="row input_fields d-flex">
                <div className="col-12">
                  <div className="form-group me-2 mb-2">
                  <label>Name</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.name} name="name" className="form-control"/>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group me-2 mb-2">
                  <label>Description</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.description} name="description" className="form-control"/>
                  </div>
                </div> 
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Total Time</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.totalTime} name="totalTime" className="form-control" placeholder='Minutes' />
                  </div>
                  {numberValid && (
                    <div style={{ color: "#F61C04" }}>Enter only number.</div>
                  )}
                </div> 
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Estimated Cost</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.estimateitme} name="estimateitme" className="form-control" />
                  </div>
                </div> 
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Currency</label>
                    <select className='form-control' name="currency" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.currency}>
                      <option value="">
                        Select Currency
                      </option>
                      { country_currency.countries.country.map((calculatedata, index) => {
                          return (
                              <option key={index} value={calculatedata.currencyCode}>
                                  {calculatedata.countryName} {calculatedata.currencyCode}
                              </option>)})
                      }
                    </select>
                    <i className="fa-solid fa-chevron-down"></i>
                  </div>
                </div> 
                <div className="col-6">
                  <div className="form-group me-2 mb-2">
                  <label>Image URL</label>
                    <input type="text" onChange={(evnt) => handleChange(evnt)} value={inputFieldsHt0.image} name="image" className="form-control"/>
                    { istrueUrl && 
                      <div style={{ color: "#F61C04" }}>Invalid URL.</div>
                    }
                  </div>
                </div> 
              </div>
              <div className='row'>
                <div className='col-md-12'>
                    {
                      inputFieldsHt.map((data, index) => {
                        const { name } = data;
                        return (
                          <div className="input_fields d-flex" key={index}>
                            <div className="col-10">
                              <div className="form-group me-2 mb-2">
                                <input type="text" onChange={(evnt) => handleChange4(index, evnt)} value={name} name="name" className="form-control" placeholder= {"Supply #"+index} />
                              </div>
                            </div>                   
                            <div className="col-2 text-center">
                              {(inputFieldsHt.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsHt(index, evnt)}><i className="fa-solid fa-minus"></i></button> : ''}
                            </div>
                          </div>
                        )
                      })
                    }
                  <div className="col mt-3 mb-3">
                    <button className="btn btn-outline-success addticket" onClick={addInputFieldHt}><i className="fa-solid fa-plus"></i> Add Supply</button>
                  </div>
                </div>
                <div className='col-md-12'>
                    {
                        inputFieldsHtTool.map((data, index) => {
                          const { name } = data;
                          return (
                            <div className="input_fields d-flex" key={index}>
                              <div className="col-10">
                                <div className="form-group me-2 mb-2">
                                  <input type="text" onChange={(evnt) => handleChangeTool(index, evnt)} value={name} name="name" className="form-control" placeholder= {"Tool #"+index} />
                                </div>
                              </div>                   
                              <div className="col-2 text-center">
                                {(inputFieldsHtTool.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsHtTool(index, evnt)}><i className="fa-solid fa-minus"></i></button> : ''}
                              </div>
                            </div>
                          )
                        })
                      }
                    <div className="col mt-3 mb-3">
                      <button className="btn btn-outline-success addticket" onClick={addInputFieldHtTool}> <i className="fa-solid fa-plus"></i> Add Tool</button>
                    </div>
                  </div>
              </div>
              <div className='row'>
                {
                  inputFieldsHtStep.map((data, index) => {
                    const { step, image, name, url } = data;
                    return (
                      <div className="row input_fields d-flex" key={index}>
                        <div className='col-12'>
                            <h4>Step #{ index+1 } {(inputFieldsHtStep.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={()=>removeInputFieldsHtStep(index)}>X</button> : ''}
                            </h4>
                        </div>
                        <div className="col-10">
                          <div className="form-group me-2 mb-2">
                          <label>Name</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={name} name="name" className="form-control"/>
                          </div>
                        </div>
                        <div className="col-10">
                          <div className="form-group me-2 mb-2">
                          <label>URL</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={url} name="url" className="form-control"  />
                            {istrueStepUrl && (istrueStepUrl[0] === index && istrueStepUrl[1]) &&
                                <div style={{ color: "#F61C04" }}>Invalid URL.</div>
                            }
                          </div>
                        </div>
                        <div className="col-10">
                          <div className="form-group me-2 mb-2">
                          <label>Image URL</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={image} name="image" className="form-control" />
                            {istrueImgUrls && (istrueImgUrls[0] === index && istrueImgUrls[1]) &&
                                <div style={{ color: "#F61C04" }}>Invalid URL.</div>
                            }
                          </div>
                        </div>
                        <div className="col-10">
                          <div className="form-group me-2 mb-2">
                            <label>Instructions</label>
                            <input type="text" onChange={(evnt) => handleChangeStep(index, evnt)} value={step} name="step" className="form-control" placeholder={"Step #"+(index+1)+": Instructions"} />
                          </div>
                        </div>                        
                      </div>
                    )
                  })
                }
                <div className="col mt-3 mb-3">
                  <button className="btn btn-outline-success addticket" onClick={addInputFieldHtStep}><i className="fa-solid fa-plus"></i> Add Step</button>
                </div>
              </div>
          </div>
          <div className='col-md-4'>
           <div className="card">
             <div className="card-header d-flex">
               <CopyToClipboard onCopy={onCopy} text={HtIsMyCopy2} >
                 <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
               </CopyToClipboard>
                 <MyButton className="btn btn-success" onClick={()=> resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i> Reset</MyButton>
                
             </div>
             <div className="card-body">
               {HtIsMyCopy2}
             </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
          </div>
        </div>
    );
}

export default Howto